import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterCollection, FilterNgMultiSelectSearch, FilterValueCollection, ContactSelectorDto, SearchContactsOptions } from '@hub/generated/models';
import { eSearchContactType, eContactSection, eColumnType } from '@hub/generated/enums';
import { Observable } from 'rxjs';
import { SearchController } from '@hub/generated/services';
import { Functions } from '@hub/common/Functions';

@Component({
  selector: 'f-filterNgMultiSelectSearch',
  templateUrl: './filterNgMultiSelectSearch.component.html'
})
export class FilterNgMultiSelectSearchComponent implements OnInit {
  constructor(
    public searchController: SearchController,
  ) { }

  @Input()
  public filter: FilterNgMultiSelectSearch;

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.value = this.getValue();      
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Input()
  public emptyValueText: string = 'Select...';

  @Input()
  public inline: boolean = false;

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public value: ContactSelectorDto[];
  public columnName: string;
  public types: eSearchContactType[];
  public suggestions: ContactSelectorDto[];
  public search$:(string) => Observable<ContactSelectorDto[]>;

  public ngOnInit() {
    this.columnName = this.filter.ColumnName;
    this.value = this.getValue();
    this.setSearch();
  }

  private setSearch() {
    if (this.filter.Types.some(c => c === eSearchContactType.TvPckgNetworkBuyer || c === eSearchContactType.TvPckgStudioProdBuyer || c === eSearchContactType.TvPckgClientTalent)) {
      this.search$ = search => this.searchController
        .SearchContacts(
          this.getSearchParameters(search)
        );
    } else if (this.filter.Types.some(c => c === eSearchContactType.TvPckgAgentUser)) {
      this.search$ = search => this.searchController.SearchContacts(this.getSearchParametersTvPckgAgentUser(search));
    }
  }

  getSearchParameters(query: string){
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(query);
    searchParameters.Section = eContactSection.TvPackage;
    searchParameters.Types = [];
    if (this.filter.Types.some(c => c === eSearchContactType.TvPckgNetworkBuyer))
      searchParameters.Types.push(eSearchContactType.TvPckgNetworkBuyer);
    if (this.filter.Types.some(c => c === eSearchContactType.TvPckgStudioProdBuyer))
      searchParameters.Types.push(eSearchContactType.TvPckgStudioProdBuyer);
    if (this.filter.Types.some(c => c === eSearchContactType.TvPckgClientTalent))
      searchParameters.Types.push(eSearchContactType.TvPckgClientTalent);
    
      return searchParameters;
  }

  getSearchParametersTvPckgAgentUser(query: string){
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(query);
    searchParameters.Section = eContactSection.TvPackage;    
    searchParameters.Types = [eSearchContactType.TvPckgAgentUser];
    return searchParameters;
  }

  public onChange(event) {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    if (this.value && Array.isArray(this.value) && this.value.length > 0) {
      result.List = [];
      this.value.forEach(val => {
        result.List.push({ Key: val.Id, Value: val.FullName, EntityType: val.EntityType.toString() });
      });
    } else
      result.List = [];

    this.ondataChange.emit(result);
  }

  private getValue(): ContactSelectorDto[]
  {
    if (this.filterCollection && this.filterCollection.List) {
      let value = this.filterCollection.List.find((item) => item.ColumnName == this.columnName);
      if (value && Array.isArray(value.List) && value.List.length > 0) {
        let list = [];
        value.List.forEach(val => {
          list.push({ Id: val.Key, FullName: val.Value, EntityType: val.EntityType });
        });
        return list;
      }
    }

    return null;
  }

}
